export default __webpack_public_path__ + "static/media/1914.17d235f8.png";